module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/search_result_page/primary_organization-ccfd5fc72408a1b8e0d547e3c23b03d9.png";